import { TASK_MANAGER_CATEGORY } from "@/config/const";

const _TASK_COLOR = {
  green: "#61C478",
  blue: "#2D9CDB",
};

const _CATEGORY_ITEMS = [
  {
    key: TASK_MANAGER_CATEGORY.ALL,
    name: "すべて",
    icon: "TrelloIcon",
  },
  {
    key: TASK_MANAGER_CATEGORY.UPLOAD,
    name: "アップロード",
    icon: "UploadCloudIcon",
    cssClassSuffix: "upload",
    color: "green",
  },
  {
    key: TASK_MANAGER_CATEGORY.DOWNLOAD,
    name: "ダウンロード",
    icon: "DownloadIcon",
    cssClassSuffix: "download",
    color: "blue",
  },
];

export default {
  data() {
    return {
      TASK_COLOR: _TASK_COLOR,
      CATEGORY_ITEMS: _CATEGORY_ITEMS,
    };
  },
  methods: {
    getCategoryItems(key) {
      return _CATEGORY_ITEMS.find(item => item.key === key);
    },
  },
};
